import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import App from "./App";

let path = window.location.hash.slice(1);
if (path) {
  window.location.hash = "";
  window.history.replaceState({}, "", `${"/homicides/"}${path}`);
}

ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById("root")
);
